// Layout.jsx
import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  CssBaseline,
  Link,
} from '@mui/material';

function Layout({ title = 'Cabot-Koppers Superfund Document Search', children }) {
  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh', // Full height
        }}
      >
      <AppBar position="static" sx={{ backgroundColor: '#003366' }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Link href="/" underline="none" sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
                <Box
                    component="img"
                    src="/img/acLogo.png" 
                    alt="Site Logo"
                    sx={{ height: 50 }}
                />
                </Link>

          <Typography variant="h6" component="div" >
            {title}
          </Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg" sx={{ mt: 4, mb: 4,}}>
        {children}
      </Container>

      <Box component="footer" sx={{ bgcolor: '#f5f5f5', py: 3, mt: 4 }}>
        <Container maxWidth="lg">
          
            <Typography variant="body2" color="textSecondary" align="center">
              © Alachua County. If you have a disability and need an accommodation in order to participate in a County program, service or public meeting, please contact the Equal Opportunity Office at 352-374-5275 at least 2 business days prior to the event. TDD users, please call 711 (Florida Relay Service). 
              <Link href="https://alachuacounty.us/Depts/EO/Pages/Website-Accessibility.aspx" target="_blank">View Alachua County's Website Accessibility Policy And Procedures</Link>
            </Typography>
          
        </Container>
      </Box>
      </Box>
    </>
  );
}

export default Layout;
